import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('prospects.routes.index'),
        name: 'lead.index',
        child: false,
        component: () =>
            import(
                /* webpackChunkName: "prospects" */ '@/views/prospects/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('prospects.breadcrumbs.index'),
                    to: { name: 'lead.index' },
                    disabled: true,
                },
            ],
            showName: i18n.t('prospects.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('prospects.routes.create'),
        name: 'lead.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "prospects" */ '@/views/prospects/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('prospects.breadcrumbs.index'),
                    to: { name: 'lead.index' },
                    disable: false,
                },
                {
                    text: i18n.t('prospects.breadcrumbs.create'),
                    to: { name: 'lead.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('prospects.routes.edit') + '/:id',
        name: 'lead.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "prospects" */ '@/views/prospects/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('prospects.breadcrumbs.index'),
                    to: { name: 'lead.index' },
                    disable: false,
                },
                {
                    text: i18n.t('prospects.breadcrumbs.edit'),
                    to: { name: 'lead.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
